import React from "react";
import { ButtonSetServices } from "../ButtonSet/ButtonSetStyled";
import { useHistory } from "react-router-dom";
import GetQuoteComponent from "../StartPage/GetQuote";
const ButtonSet = () => {
  let history = useHistory();
  const signUp = () => {
    localStorage.setItem("guestUser", false);
    localStorage.setItem("postInventory", false);
    localStorage.setItem("memberShipType", "");
    history.push("/registration");
  };
  const contactUs = () => {
    history.push("/contact-us");
  };
  return (
    <>
      <ButtonSetServices>
        <button onClick={contactUs}>CONTACT US</button>
        <GetQuoteComponent />
        {/* <button>REQUEST A QUOTE</button>
         */}
        <button
          onClick={() => {
            history.push("/search-inventory");
          }}
        >
          SEARCH AVAILABLE INVENTORY
        </button>
      </ButtonSetServices>
    </>
  );
};

export default ButtonSet;
